<script setup>
  import { ref, computed, inject, defineAsyncComponent } from 'vue'

  import { useMediaQuery } from '@/composables/useMediaQuery';

  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from '@/components/DataContainer.vue';

  const StationInfoContent = defineAsyncComponent(() => import('@/components/StationInfoContent.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
      required: true
    }
  });

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const isNCWind = inject('isNCWind');

  const minHeight = computed(() => {
    if (isNCWind) {
      return isDesktop.value ? '172px' : '385px';
    }

    return isDesktop.value ? '125px' : '170px';
  });

  const content = ref(null);
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="station-info"
      title="Station Info"
      :minHeight="minHeight"
      :metaActions="false"
      >
      <template #content="{ isVisible }">
        <DataContainer style="width: 100%; height: 100%;">
          <StationInfoContent
            v-if="isVisible"
            v-model:content="content"
          />
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>